import { ErrorOutlineOutlined, MessageTooltip } from "@qivia/ui";
import { useParams } from "react-router-dom";
import { Trans } from "react-i18next";
import styled from "styled-components";
import "../../../i18n/i18n";

export const VehicleConnectionsTab = () => {
  const params = useParams();

  if (params.tab !== "vehicle_connections") {
    return null;
  }

  return (
    <StyledContainer>
      <MessageTooltip
        type={"NEUTRAL"}
        iconLeft={<ErrorOutlineOutlined />}
        text={<Trans i18nKey="electric_charging.vehicle_connections.banner" />}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
